import type { PropsWithChildren } from 'react';
import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

const Wrapper = ({ children }: PropsWithChildren) => (
  <>
    <div className="md:flex hidden flex-col gap-4">
      {children}
    </div>
    <SkeletonParent className="md:hidden p-4 rounded-2xl flex flex-col gap-4">
      {children}
    </SkeletonParent>
  </>
);

export const GmRewardsSkeleton = ({ count }: { count: number }) => {
  return (
    <Wrapper>
      <SkeletonParent className="md:block hidden rounded-lg h-5.5 w-29.5 self-start">
        <SkeletonChild />
      </SkeletonParent>

      <div className="flex md:hidden items-center gap-2">
        <SkeletonChild className="rounded-full size-6 shrink-0" />
        <SkeletonChild className="rounded-lg h-5 w-20" />
      </div>

      <div className="flex flex-col md:grid grid-cols-3 gap-4">
        {
          Array.from({ length: count }).map(
            (_, i) => (
              <SkeletonParent
                key={i}
                className="rounded-2xl "
              >
                <SkeletonChild className="rounded-[inherit] gap-3 flex justify-between items-center h-35 w-full pr-[0.313rem] md:pr-[0.85rem]">
                  <div className="flex flex-col justify-between w-full pl-4 py-3 h-full">
                    <div className="flex flex-col w-full gap-1.5">
                      <SkeletonChild className="rounded-lg h-4 md:h-4.5 max-w-25 md:max-w-30 w-full" />
                      <SkeletonChild className="rounded-lg h-5 md:h-3.5 max-w-15 md:max-w-22.5 w-full" />
                    </div>

                    <SkeletonChild className="rounded-2xl h-8 w-17" />
                  </div>

                  <SkeletonChild className="rounded-2xl h-32.5 shrink-0 w-full max-w-32.5" />
                </SkeletonChild>
              </SkeletonParent>
            ),
          )
        }
      </div>
    </Wrapper>
  );
};
